<template>
  <div class="ver-atencion">
    <h3 class="text-center mb-3 font-weight-bold">Ver Item Atención</h3>

    <b-card class="section-card">
      <h5 class="section-title">Información del ítem</h5>
      <b-row class="mt-1">
        <b-col md="4" class="mb-1">
          <small class="text-muted d-block">Código</small>
          <span class="font-weight-bold h5 mb-0 d-block">{{ atencion.codTarifa || 'No disponible' }}</span>
        </b-col>
        <b-col md="4" class="mb-1">
          <small class="text-muted d-block">Nombre</small>
          <span class="font-weight-bold h5 mb-0 d-block">{{ atencion.descripcion || 'No disponible' }}</span>
        </b-col>
        <b-col md="4" class="mb-1">
          <small class="text-muted d-block">Precio</small>
          <span class="font-weight-bold h5 mb-0 d-block">{{ formatCurrency(atencion.precio) }}</span>
        </b-col>
      </b-row>
    </b-card>

    <b-card class="section-card">
      <h5 class="section-title">Precios</h5>
      <table class="table table-sm table-precios">
        <thead>
          <tr>
            <th>Entidad</th>
            <th class="text-right">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="fila in filasPrecios" :key="fila.entidad">
            <td class="font-weight-bold">{{ fila.entidad }}</td>
            <td class="text-right">{{ fila.precio }}</td>
          </tr>
        </tbody>
      </table>
    </b-card>

    <b-card v-if="estadosCobertura.length" class="section-card">
      <h5 class="section-title">Estados de Cobertura</h5>
      <div class="d-flex flex-wrap">
        <div class="estado-chip mr-4 mb-2" v-for="estado in estadosCobertura" :key="estado.label">
          <span :class="estado.activo ? 'text-success' : 'text-danger'">
            <i :class="estado.activo ? 'fas fa-check-circle' : 'fas fa-minus-circle'" class="mr-1"></i>
            {{ estado.label }}
          </span>
        </div>
      </div>
    </b-card>

    <b-card class="section-card">
      <h5 class="section-title">Establecimientos</h5>
      <div class="establecimientos-grid">
        <div v-for="est in establecimientos" :key="est.id" class="est-item">
          <span class="font-weight-bold text-uppercase d-block">{{ est.nombre }}</span>
          <span :class="est.activo ? 'text-success' : 'text-danger'" class="d-flex align-items-center">
            <i :class="est.activo ? 'fas fa-check-circle' : 'fas fa-times-circle'" class="mr-1"></i>
            {{ est.activo ? 'Activo' : 'Inactivo' }}
          </span>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import { establecimientosService } from '@/views/administracion/services';
import { BContainer, BRow, BCol, BCard, BForm, BFormGroup, BFormInput } from 'bootstrap-vue';

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
  },
  props: ['token'],
  data() {
    return {
      atencion: {
        id: '',
        token: '',
        descripcion: '',
        codTarifa: '',
        precio: 0,
        establecimiento: '',
        estado: 0,
      },
      estadoJson: {},
      establecimientosList: [],
    };
  },
  async created() {
    this.establecimientosList = await establecimientosService.getForSelect();
    if (this.token) {
      this.fetchAtencion(this.token);
    }
  },
  watch: {
    token(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.fetchAtencion(newVal);
      }
    },
  },
  methods: {
    formatCurrency(value) {
      const num = Number(value || 0);
      return `$${num.toFixed(2)}`;
    },
    parseFlexibleJson(value) {
      if (!value) return {};
      if (typeof value === 'object') return value;
      try {
        return JSON.parse(value);
      } catch (e) {
        try {
          const fixed = value
            .replace(/'/g, '"')
            .replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":');
          return JSON.parse(fixed);
        } catch (error) {
          console.warn('No se pudo parsear JSON flexible', value);
          return {};
        }
      }
    },
    buildEstablecimientos(estRaw) {
      const map = (this.establecimientosList || []).reduce((acc, est) => {
        if (est && est.value !== undefined && est.value !== null) {
          acc[String(est.value)] = est.text;
        }
        return acc;
      }, {});

      if (!estRaw) return [];

      // Objeto único { id, Descripcion }
      if (typeof estRaw === 'object' && !Array.isArray(estRaw) && estRaw.id) {
        const id = String(estRaw.id);
        return [
          {
            id,
            nombre: estRaw.Descripcion || map[id] || id,
            activo: true,
          },
        ];
      }

      // Lista de objetos
      if (Array.isArray(estRaw) && estRaw.length && estRaw[0]?.id) {
        return estRaw.map((est) => {
          const id = String(est.id);
          return {
            id,
            nombre: est.Descripcion || map[id] || id,
            activo: est.activo !== false,
          };
        });
      }

      // Cadena separada por comas o con estado "id:valor"
      if (typeof estRaw === 'string') {
        return estRaw
          .split(',')
          .map((e) => e.trim())
          .filter(Boolean)
          .map((entry) => {
            const [idRaw, estadoRaw] = entry.split(':').map((val) => (val ? val.trim() : ''));
            const id = idRaw || entry;
            const nombre = map[id] || id;
            const activo = estadoRaw ? estadoRaw !== '0' && estadoRaw.toLowerCase() !== 'inactivo' : true;
            return { id, nombre, activo };
          });
      }

      return [];
    },
    async fetchAtencion(tokenatencion, pagina_actual = 1, pageSize = 15, isFallback = false) {
      const queryWithExtras = `
        query MyQuery($page:Int , $pageSize: Int, $tokenAtencion: String) {
          allCarteraAtencion(page: $page, pageSize: $pageSize, tokenAtencion: $tokenAtencion) {
            message
            status
            total
            atenciones {
              token
              descripcion
              estado
              id
              precio
              codTarifa
              establecimiento
            }
          }
        }
      `;

      const queryFallback = `
        query MyQuery($page:Int , $pageSize: Int, $tokenAtencion: String) {
          allCarteraAtencion(page: $page, pageSize: $pageSize, tokenAtencion: $tokenAtencion) {
            message
            status
            total
            atenciones {
              token
              descripcion
              estado
              id
              precio
              codTarifa
              establecimiento {
                Descripcion
                id
              }
            }
          }
        }
      `;

      const query = isFallback ? queryFallback : queryWithExtras;

      const variables = {
        tokenAtencion: tokenatencion,
        page: pagina_actual,
        pageSize: pageSize,
      };

      try {
        const response = await axios.post(rutas.axios + 'api', {
          query: query,
          variables: variables,
        });
        if (response.data?.errors && response.data.errors.length && !isFallback) {
          // Si el esquema no soporta campos extra, reintenta con consulta básica.
          return this.fetchAtencion(tokenatencion, pagina_actual, pageSize, true);
        }

        if (response.data.data.allCarteraAtencion.status === 'Success') {
          const data = response.data.data.allCarteraAtencion.atenciones;
          if (data && data.length) {
            const dataaten = data[0];
            this.atencion = {
              token: dataaten.token,
              descripcion: dataaten.descripcion,
              codTarifa: dataaten.codTarifa,
              estado: dataaten.estado,
              precio: dataaten.precio,
              establecimiento: dataaten.establecimiento,
            };
            this.estadoJson = {};
            this.precioJson = {};
          }
        } else {
          console.error('Error al obtener la atencion medica:', response.data.message);
        }
      } catch (error) {
        if (!isFallback) {
          // Un error de esquema puede solventarse usando la consulta sin campos adicionales.
          return this.fetchAtencion(tokenatencion, pagina_actual, pageSize, true);
        }
        console.error('Error al realizar la consulta GraphQL:', error);
      }
    },
  },
  computed: {
    filasPrecios() {
      const format = (valor) => this.formatCurrency(valor || 0);
      return [
        { entidad: 'Precio', precio: format(this.atencion.precio) },
      ];
    },
    estadosCobertura() {
      if (!this.estadoJson || Object.keys(this.estadoJson).length === 0) return [];
      return [
        { label: 'IESS', activo: !!this.estadoJson.iess },
        { label: 'ISSFA', activo: !!this.estadoJson.issfa },
        { label: 'ISSPOL', activo: !!this.estadoJson.isspol },
        { label: 'PARTICULAR', activo: !!this.estadoJson.particular },
      ].filter(e => e.activo !== undefined);
    },
    establecimientos() {
      return this.buildEstablecimientos(this.atencion.establecimiento);
    },
  },
};
</script>

<style scoped>
.ver-atencion h5 {
  font-weight: 600;
}

.section-card {
  margin-bottom: 14px;
  border: 1px solid #f0f0f0;
}

.section-title {
  margin-bottom: 8px;
  color: #6c757d;
  font-size: 14px;
  letter-spacing: 0.2px;
}

.table-precios thead {
  background: #f8f8fb;
}

.table-precios th {
  border-top: none;
  font-size: 12px;
  color: #6c757d;
}

.estado-chip {
  font-size: 14px;
}

.establecimientos-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  column-gap: 12px;
  row-gap: 10px;
}

.est-item {
  padding: 4px 0;
}
</style>
